import { CheckboxInput } from "@fidget/common/components/form/checkboxInput";
import { L10nId } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import settingStyles from "../../../../styles/settings.css";
import { ElementForm } from "../../settingsForms/elementForm/elementForm/elementForm";
import { VerticalSeparator } from "../../settingsForms/separators/verticalSeparator/verticalSeparator";
import roleEditStyles from "../edit/roleEdit.css";
import styles from "./permissionsGroup.css";

interface Props {
  name: string;
  textId: L10nId;
  isSelected: boolean;
  onSelectedChange: (selected: boolean) => void;
}

export const PermissionsGroup = observer(function PermissionGroupComponent(props: Props) {
  const { textId, name, isSelected, onSelectedChange } = props;

  return (
    <ElementForm className={styles.relative}>
      <div className={classNames(roleEditStyles.content, styles.permission)}>
        <span
          className={classNames(
            settingStyles["form-label-font"],
            roleEditStyles.flex,
            styles["margin-bottom"]
          )}
        >
          {intl.formatMessage("settings.rolesSettings.permissions.permission")}
        </span>
        <span className={classNames(styles["form-content-font"], roleEditStyles.flex)}>{name}</span>
      </div>
      <VerticalSeparator style="margin-around" />
      <div className={classNames(roleEditStyles.content, styles.functionality)}>
        <span
          className={classNames(
            settingStyles["form-label-font"],
            roleEditStyles.flex,
            styles["margin-bottom"]
          )}
        >
          {intl.formatMessage("settings.rolesSettings.permissions.functionality")}
        </span>
        <div>
          <div className={styles.row}>
            <div className={roleEditStyles.flex}>
              <span
                className={classNames(
                  styles["form-label-font"],
                  styles["functionality-description"]
                )}
              >
                {intl.formatMessage(textId)}
              </span>
            </div>
          </div>
        </div>
      </div>
      <VerticalSeparator style={"margin-around"} />
      <div className={classNames(roleEditStyles.content, styles.checkbox)}>
        <div className={roleEditStyles.flex}>
          <div className={classNames(styles["checkbox"])}>
            <CheckboxInput
              smallStyle
              displayNoColors
              noMarginBottom
              id={textId}
              onChange={onSelectedChange}
              value={isSelected}
              label={intl.formatMessage("settings.roleSettings.enabled")}
            />
          </div>
        </div>
      </div>
    </ElementForm>
  );
});
